export type RoomCountdownAccess = {
  loaded: boolean
  publicCanPost: boolean
  opensAt: string | null
  locksAt: string | null
  state: 'pre' | 'live' | 'post' | 'locked'
}

export function roomCountdownTarget(access: RoomCountdownAccess, now: number) {
  if (!access.loaded) return { label: 'Checking room time…', target: null }
  if (access.state === 'locked') return { label: 'Member chat is closed', target: null }
  const rawTarget = access.publicCanPost ? access.locksAt : access.opensAt
  const target = rawTarget ? Date.parse(rawTarget) : NaN
  if (!Number.isFinite(target)) return { label: 'Room schedule is being updated', target: null }
  if (now >= target) return { label: access.publicCanPost ? 'Member chat is closing…' : 'Member chat is opening…', target: null }
  return { label: access.publicCanPost ? 'Room closes in…' : 'Room opens in…', target }
}
